import { SelectOptionType } from '@octano/global-ui';
import { ClassroomSelectOptionType, RecordToEditBody } from './types';

export const getSelectOptionsFromData = (
  items?: ClassroomSelectOptionType[] | null,
): SelectOptionType[] => {
  if (!items || !Array.isArray(items)) {
    return [];
  }
  return items.map((item) => ({
    label: item.name,
    value: item.id,
  }));
};

export const getDefaultValues = (recordToEdit?: RecordToEditBody) => {
  return recordToEdit
    ? {
        code: recordToEdit.code,
        name: recordToEdit.name,
        capacity: recordToEdit.capacity,
        type: { label: recordToEdit.type.name, value: recordToEdit.typeId },
        campus: {
          label: recordToEdit.campus.name,
          value: recordToEdit.campusId,
        },
        typeId: recordToEdit.typeId,
      }
    : {
        code: '',
        name: '',
        capacity: 0,
        type: null,
        campus: null,
      };
};
